import { Condition } from "@/commonTypes/question";
import { AnswerValue } from "@/commonTypes/answer";

export function isConditionMet(
  conditions: Condition[] | undefined,
  answers: Record<string, AnswerValue>,
): boolean {
  if (!conditions || conditions.length === 0) return true;
  return conditions.every(({ condition, values, negate }) => {
    const answer = answers[condition];
    if (answer == null) return true;
    const allowed = Array.isArray(values) ? values : [values];
    let matches: boolean;
    if (Array.isArray(answer)) {
      matches = answer.some((a) => allowed.includes(a));
    } else {
      matches = allowed.includes(answer as string);
    }
    return negate ? !matches : matches;
  });
}
